export default __webpack_public_path__ + "static/media/line-arrow-right-outline-16px.ff356c35.svg";